import { useState, type PropsWithChildren, type ReactNode } from "react";

interface DisclosureProps extends PropsWithChildren {
  title: string;
  // One line naming what is inside, so the summary is legible while closed.
  hint?: ReactNode;
  defaultOpen?: boolean;
  tone?: "plain" | "danger";
}

// Secondary tasks (rename, archive, reconcile, record) live behind this
// instead of occupying the screen. The body is mounted only while open: a
// closed <details> still lays its contents out, so rendering them anyway
// would keep their forms, fonts and widths in the page.
export function Disclosure({ title, hint, defaultOpen = false, tone = "plain", children }: DisclosureProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <details className={`disclosure ${tone}`} open={open} onToggle={(event) => setOpen(event.currentTarget.open)}>
      <summary>
        <span className="disclosure-title">{title}</span>
        {hint ? <span className="disclosure-hint">{hint}</span> : null}
        <span className="disclosure-mark" aria-hidden="true">›</span>
      </summary>
      {open ? <div className="disclosure-body">{children}</div> : null}
    </details>
  );
}
